import type { Unit } from "web_myplann/Shared/Utils/units";

const NBSP = "\u00A0";

export const numberFormatter = new Intl.NumberFormat("cs-CZ");

export const signedNumberFormatter = new Intl.NumberFormat("cs-CZ", {
	signDisplay: "exceptZero",
});

export const formatNumber = (value: number) =>
	numberFormatter.format(Math.round(value));

export const roundNumber = (val: number, decimalPlaces = 2): number =>
	Number(val.toFixed(decimalPlaces));

export const truncateNumber = (num: number, decimals = 2): number => {
	const factor = 10 ** decimals;
	return Math.trunc(num * factor) / factor;
};

export const formatThousands = (raw: string): string => {
	const digits = raw.replace(/\D/g, "");
	if (!digits) return "";
	return digits.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
};

export const parseThousands = (raw: string): number | undefined => {
	const digits = raw.replace(/\D/g, "");
	if (!digits) return undefined;
	const numeric = Number(digits);
	return Number.isNaN(numeric) ? undefined : numeric;
};

export const parseThousandsFloat = (raw: string): number | undefined => {
	const cleaned = raw.replace(/[^\d.,]/g, "").replace(",", ".");
	if (!cleaned || cleaned === ".") return undefined;
	const numeric = Number(cleaned);
	return Number.isNaN(numeric) ? undefined : numeric;
};

export const formatPercent = (value: number, decimalPlaces = 1): string =>
	`${roundNumber(value, decimalPlaces)}${NBSP}%`;

export const floorFormatter = (
	from: number | null | undefined,
	to: number | null | undefined,
	emptyVal = "",
) => {
	if (!from && !to) return emptyVal;
	if (!from) return `${to}`;
	if (!to) return `${from}`;

	return `${from} - ${to}`;
};

export const unitFormatter = (
	val: number | null | undefined,
	unit: Unit,
	emptyVal = "",
) => {
	return val ? `${val.toLocaleString("cs-CZ")} ${unit}` : emptyVal;
};
